import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import KYCSubmission from "modules/kyc-submission/kyc-submission.module";
import ViewKYC from "modules/kyc-submission/view-kyc/view-kyc.module";

const KYCPage = () => {
  return (
    <Switch>
      <Route exact path={Path.KYCSubmissions} component={KYCSubmission} />
      <Route path={Path.ViewKYCSubmissions} component={ViewKYC} />
      <Redirect to={Path.ViewKYCSubmissions} />
    </Switch>
  );
};

export default KYCPage;
